export const isAdminGroup = (groups: string[]): boolean => {
  return !!groups.find((item: string) => item.includes('admin-group'))
}
